export const iconFontAwesomeSportsFitnessStopwatch20 = (
	<i className="fa-solid fa-stopwatch-20"></i>
);
